import React from "react";
import { Button, ButtonGroup, Box, Menu, MenuItem } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import MainHeader from "../../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../../components/MainHeaderButtonsWrapper";
import Title from "../../../components/Title";
import ChannelIcon from "../../../components/ChannelIcon";
import { Can } from "../../../components/Can";
import { i18n } from "../../../translate/i18n";
import { toast } from "react-toastify";
import { getInstagramAuthUrl } from "../../../services/facebookOnboarding.api";
import { PROVIDERS } from "../../../constants/whatsappProviders";

/**
 * Canales que se pueden dar de alta, en el orden en que se ofrecen.
 *
 * WHY una lista y no seis bloques JSX: eran seis `MenuItem` idénticos salvo tres textos,
 * y los seis pintaban el MISMO icono de WhatsApp cambiando solo el color — el usuario veía
 * seis logos de WhatsApp de colores. Con la lista, añadir un canal es una entrada más y el
 * logo lo resuelve `ChannelIcon` desde el catálogo de proveedores.
 *
 * Instagram entra SOLO por Business Login. La alta manual con token de página se retiró:
 * ofrecía dos caminos al mismo canal y el manual no recibe DMs reales (doc 0373).
 */
const CHANNEL_OPTIONS = [
  {
    key: "baileys",
    provider: PROVIDERS.BAILEYS,
    title: "WhatsApp Nativo",
    subtitle: "Baileys — directo al servidor WA",
    onSelect: ({ onAdd }) => onAdd("baileys"),
  },
  {
    key: "evolution",
    provider: PROVIDERS.EVOLUTION,
    title: "Evolution API",
    subtitle: "HTTP REST — servidor externo",
    onSelect: ({ onAdd }) => onAdd("evolution"),
  },
  {
    key: "waba",
    provider: PROVIDERS.WABA,
    title: "WABA Meta",
    subtitle: "Cloud API oficial de Meta",
    onSelect: ({ onAdd }) => onAdd("waba"),
  },
  {
    key: "facebook",
    provider: PROVIDERS.FACEBOOK,
    title: "Facebook Messenger",
    subtitle: "Meta Graph API — página",
    onSelect: ({ onAdd }) => onAdd("facebook"),
  },
  {
    key: "instagram",
    provider: PROVIDERS.INSTAGRAM,
    title: "Instagram",
    subtitle: "Instagram Business Login — DM reales",
    onSelect: async () => {
      try {
        const { data } = await getInstagramAuthUrl();
        if (data?.url) {
          window.location.href = data.url;
        } else {
          toast.error("No se pudo obtener la URL de Instagram");
        }
      } catch (e) {
        toast.error(
          "No se pudo iniciar el login de Instagram (verifica INSTAGRAM_APP_ID/SECRET en el servidor)"
        );
      }
    },
  },
];

/**
 * Header de la página Connections.
 * Contiene el título, el botón "AGREGAR" y el menú desplegable de selección de proveedor.
 *
 * @param {object}   user               — Objeto usuario con `profile` para <Can>
 * @param {Element}  addMenuAnchorEl    — Elemento DOM ancla del menú de proveedores
 * @param {Function} setAddMenuAnchorEl — Setter para abrir/cerrar el menú
 * @param {Function} onAdd              — handleOpenWhatsAppModal (acepta provider string opcional)
 */
const ConnectionsHeader = ({ user, addMenuAnchorEl, setAddMenuAnchorEl, onAdd }) => (
  <MainHeader>
    <Title>{i18n.t("connections.title")}</Title>
    <MainHeaderButtonsWrapper>
      <Can
        role={user.profile}
        perform="connections-page:addConnection"
        yes={() => (
          <>
            <Box
              position="relative"
              display="inline-flex"
              style={{ zIndex: 1300, position: 'relative' }}
            >
              <ButtonGroup
                variant="contained"
                color="primary"
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                  overflow: 'visible',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <Button
                  onClick={() => onAdd()}
                  style={{
                    textTransform: 'uppercase',
                    fontWeight: '600',
                    fontSize: '14px',
                    padding: '10px 20px',
                    letterSpacing: '0.5px',
                  }}
                >
                  AGREGAR
                </Button>
                <Button
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAddMenuAnchorEl(e.currentTarget);
                  }}
                  style={{
                    minWidth: '36px',
                    padding: '0 8px',
                    borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
                  }}
                >
                  <ArrowDropDown />
                </Button>
              </ButtonGroup>
              <Menu
                anchorEl={addMenuAnchorEl}
                open={Boolean(addMenuAnchorEl)}
                onClose={() => setAddMenuAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                style={{ zIndex: 1301 }}
                PaperProps={{
                  style: {
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    minWidth: '200px',
                    marginTop: '4px',
                    zIndex: 1301,
                  },
                }}
                MenuListProps={{ style: { padding: '4px 0' } }}
                getContentAnchorEl={null}
              >
                {CHANNEL_OPTIONS.map((opt) => (
                  <MenuItem
                    key={opt.key}
                    onClick={() => {
                      setAddMenuAnchorEl(null);
                      opt.onSelect({ onAdd });
                    }}
                    style={{ padding: '10px 20px', fontSize: '14px' }}
                  >
                    <Box display="flex" alignItems="center" width="100%">
                      <ChannelIcon
                        provider={opt.provider}
                        size={22}
                        style={{ marginRight: 10 }}
                      />
                      <Box>
                        <Box style={{ fontWeight: 600, fontSize: '13px' }}>{opt.title}</Box>
                        <Box style={{ fontSize: '11px', color: '#888' }}>{opt.subtitle}</Box>
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </>
        )}
      />
    </MainHeaderButtonsWrapper>
  </MainHeader>
);

export default ConnectionsHeader;
